import { render, staticRenderFns } from "./Status-Badge.vue?vue&type=template&id=31b4b932&scoped=true"
import script from "./Status-Badge.vue?vue&type=script&lang=js"
export * from "./Status-Badge.vue?vue&type=script&lang=js"
import style0 from "./Status-Badge.vue?vue&type=style&index=0&id=31b4b932&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b4b932",
  null
  
)

export default component.exports